// extracted by mini-css-extract-plugin
module.exports =  {"root":"fOvIWEeUuao4EWnZVKCd","label":"Q03JsEAYCNzmuUlyJhbQ"};